// extracted by mini-css-extract-plugin
export default {"content":"KBsEJyuwKcTeBLE5OePz","icon":"o7XAmwP3pM4kwJ_C3iwL","text":"FUKxzKVtY0cv4fDcfpeP"};